export default "__VITE_ASSET__9984f95b__"